import { Box, Button, Grid, Typography } from '@mui/material'
import ROUTE from 'constant/route'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { Show } from 'permission/Show'
import { useHistory } from 'react-router-dom'

function NoPermissionPage() {
    const history = useHistory()
    const { isMobile } = useScreenSize()
    return (
        <Grid
            sx={{
                zIndex: -88,
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                margin: 0,
                backgroundColor: 'topside.paper',
            }}
            container
            justifyContent="center"
            alignItems="center"
        >
            <Grid
                container
                item
                justifyContent="center"
                spacing={2}
                alignItems="center"
            >
                <Grid item style={{ textAlign: isMobile ? 'center' : 'right' }}>
                    <Typography style={{ padding: 5 }} variant="h5">
                        401
                    </Typography>
                    <Typography style={{ padding: 5 }} variant="h3">
                        You don't have permission to view this page.
                    </Typography>
                    <Button
                        style={{ padding: 5, marginTop: 10 }}
                        className="textNone"
                        onClick={() => history.push(ROUTE.LOGIN)}
                        variant="outlined"
                        color="primary"
                    >
                        Return
                    </Button>
                </Grid>
                <Box
                    sx={{
                        display: {
                            md: 'block',
                            lg: 'none',
                        },
                    }}
                >
                    <Show when={[]}>
                        <span style={{ fontSize: 150 }}>&#128517;</span>
                    </Show>
                </Box>
            </Grid>
        </Grid>
    )
}

export default NoPermissionPage
